
import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import useEventEmitter, {
  emitEvent,
} from "../../../hooks/useEventEmitter";

import SideDrawer, {
  SideDrawerBody,
} from "../../../components/SideDrawer";

import RevisedCaseNoteList from "./RevisedCaseNoteList";
import { VOICE_NOTE_REVISION_LOG } from "../types/CommonTypes";

const REVISED_CASE_NOTE_DRAWER_EVENT =
  "REVISED_CASE_NOTE_DRAWER_EVENT";

export type RevisedCaseNoteDrawerProps = {
  note?: string;
  revisionLogs?: Array<VOICE_NOTE_REVISION_LOG>;
};

export const toggleRevisedCaseNoteDrawer = (
  data?: RevisedCaseNoteDrawerProps,
) => {
  emitEvent(REVISED_CASE_NOTE_DRAWER_EVENT, data);
};

const RevisedCaseNoteDrawer = () => {
  const { t } = useTranslation();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [caseNoteDetail, setCaseNoteDetail] =
    useState<RevisedCaseNoteDrawerProps>();

  const { revisionLogs } = caseNoteDetail ?? {};

  useEventEmitter(
    REVISED_CASE_NOTE_DRAWER_EVENT,
    (data?: RevisedCaseNoteDrawerProps) => {
      setIsDrawerOpen((prev) => !prev);
      if (data) {
        setCaseNoteDetail(data);
      }
    },
  );

  return (
    <SideDrawer
      visible={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      title={t("Revised_Voice_Note")}
    >
      <SideDrawerBody>
        <Box sx={styles.container}>
          {/* Header */}
          <Box sx={styles.header}>
            <Typography sx={styles.title}>
              {t("Voice_Note_Revisions_for")}
            </Typography>
          </Box>

          {/* Revision History */}
          <Box sx={styles.revisionContainer}>
            <RevisedCaseNoteList
              revisionLogs={revisionLogs}
            />
          </Box>
        </Box>
      </SideDrawerBody>
    </SideDrawer>
  );
};

const styles = {
  container: {
    width: "100%",
    boxSizing: "border-box",
  },

  header: {
    display: "flex",
    alignItems: "center",
    minHeight: "44px",
    backgroundColor: "#E7E7E7",
    borderLeft: "4px solid #5921F2",
    px: "12px",
    py: "8px",
    boxSizing: "border-box",
  },

  title: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: "#111111",
  },

  revisionContainer: {
    mt: "12px",
    backgroundColor: "#E7E7E7",
    borderRadius: "12px",
    p: "14px",
    boxSizing: "border-box",
  },
};

export default RevisedCaseNoteDrawer;
